import React from 'react'
import { Label } from 'react-bootstrap'

class DaysOpen extends React.Component {
	render() {
		if (this.props.value >= 0 && this.props.value !== "") {
			let bg = 'default';
			let type = 'default';

			if (this.props.value < 30) {
				bg = '#43d162';
				type = '#000000';
			}
			else if (this.props.value >= 30 && this.props.value <= 60) {
				bg = '#dec02c';
				type = '#000000';
			}
			else if (this.props.value > 60) {
				bg = '#ba1111';
				type = '#FFFFFF';
			}

			let style = {
				backgroundColor: bg,
				color: type,
				display: "block",
				position: "relative",
				width: "100%",
				height: "34px",
				paddingTop: "10px",
				margin: "0",
				padding: "0"
			};

			return (<Label style={style}><span style={{ display: "block", paddingTop: "12px" }}>{this.props.value}</span></Label>);
		}
		else {
			return null;
		}
	}
}


export default DaysOpen;



// WEBPACK FOOTER //
// ./src/areas/admin/shared/DaysOpen.js